import { createPinia } from 'pinia';
import { isRef } from 'vue';

const store = createPinia();

export const assignState = (target, data) => {
  if (isRef(target)) {
    target.value = data;
  } else {
    Object.entries(data).forEach(([key, value]) => {
      if (Object.hasOwn(target, key)) {
        target[key] = value;
      }
    });
  }
};

export default store;
